export const EXPERIENCIA_ACTUAL = {
  empresa: "Estudio Rocha & Asociados",
  programa: "Programa +26 - Gobierno de Córdoba",
  rol: "Desarrolladora Front-End",
  periodo: "Actualidad",
  tecnologias: ["React.Js", "WordPress", "Vue.js","Quasar","MongoDb", "Node.Js"],
  descripcion: [
    "Soy Desarrolladora Front-End y en mi última experiencia laboral formé parte del equipo de desarrollo en Estudio Rocha & Asociados (Programa +26), donde pude trabajar en la creación, mejora y mantenimiento de interfaces web e-commerce.",
    "Mi rol consistió en la implementación del diseño front-end a partir de prototipos en React, migrando la estructura a un lenguaje más moderno y actual como Vue.Js y quasar.",
    "Participé en la gestión y actualización de contenidos en sitios de WordPress del Gobierno de Córdoba, cumpliendo con los tiempos de entrega y manteniendo una comunicación fluida con el equipo de diseño y desarrollo para asegurar la coherencia visual y funcional de los proyectos.",
    "Aprendí a deployar y publicar proyectos para entornos web, Android y macOS, ampliando mi visión sobre el ciclo completo de un producto digital.",
    "En estos últimos meses, pude ampliar mi perfil capacitándome en automatización, web scraping, Vue.js 3 y n8n desarrollando scripts que se utilizan internamente para optimizar procesos y mejorar la eficiencia del equipo.",
  ],
};

export const APORTES = [
  {
    icono: "💻",
    titulo: "Desarrollo front-end",
    detalle: "React, JavaScript, Bootstrap, avanzando en Vue.js y quasar",
  },
  {
    icono: "🧩",
    titulo: "WordPress",
    detalle: "Integración y gestión de contenidos",
  },
  {
    icono: "🤖",
    titulo: "Automatización",
    detalle: "Node.js, Puppeteer, n8n y web scraping",
  },
  {
    icono: "🔍",
    titulo: "Datos",
    detalle: "Organización, análisis y procesamiento",
  },
  {
    icono: "🎨",
    titulo: "Diseño UX/UI",
    detalle: "Orientado a la experiencia de usuario",
  },
  {
    icono: "🚀",
    titulo: "Proactividad",
    detalle: "Aprendizaje continuo y mirada creativa",
  },
];
